import { useEffect, useRef } from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { currentStructureSetIdState } from '~/state/atoms/structureSet/structureSetAtoms';
import {
    boundingRoiConstraintState,
    collisionConstraintState,
} from '~/state/atoms/toolsAtoms';

/**
 * Resets the Inside/Outside drawing constraints whenever the active
 * structure set changes. A constraint names structures of the set it was
 * set up in, none of which the new set holds, so it would be left armed
 * with nothing to constrain against. The first render resets nothing.
 */
export function useResetDrawingConstraintsOnSetChange(): void {
    const currentStructureSetId = useRecoilValue(currentStructureSetIdState);
    const resetBounding = useResetRecoilState(boundingRoiConstraintState);
    const resetCollision = useResetRecoilState(collisionConstraintState);
    const previousRef = useRef(currentStructureSetId);
    useEffect(() => {
        if (previousRef.current === currentStructureSetId) {
            return;
        }
        previousRef.current = currentStructureSetId;
        resetBounding();
        resetCollision();
    }, [currentStructureSetId, resetBounding, resetCollision]);
}
